import axios from '@/utils/request';
const prefix = process.env.VUE_APP_API_PREFIX_1;
const baseOriginURL = `${prefix}/role`;

// 获取角色列表
const GetRoleList = params => {
  return axios.get(`${baseOriginURL}/GetRoleList`, { params });
};

// 获取角色详情
const GetRoleRecord = params => {
  return axios.get(`${baseOriginURL}/GetRoleRecord`, { params });
};

// 创建角色
const CreateRole = data => {
  return axios.post(`${baseOriginURL}/CreateRole`, data);
};

// 修改角色
const UpdateRole = data => {
  return axios.put(`${baseOriginURL}/UpdateRole`, data);
};

// 修改角色状态
const UpdateRoleStatus = data => {
  return axios.put(`${baseOriginURL}/UpdateRoleStatus`, data);
};

// 修改角色状态
const DeleteRole = data => {
  return axios.delete(`${baseOriginURL}/DeleteRole`, data);
};

// 修改角色推送设置
const UpdatePushSetting = data => {
  return axios.put(`${baseOriginURL}/UpdatePushSetting`, data);
};

export {
  GetRoleList,
  GetRoleRecord,
  CreateRole,
  UpdateRole,
  UpdateRoleStatus,
  DeleteRole,
  UpdatePushSetting,
};
